export default "__VITE_ASSET__nhKAtiZw__"